import { render, staticRenderFns } from "./SlideCopy.vue?vue&type=template&id=2f039a5a&scoped=true&"
import script from "./SlideCopy.vue?vue&type=script&lang=js&"
export * from "./SlideCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f039a5a",
  null
  
)

export default component.exports